module.exports = __webpack_public_path__ + "static/media/meddata1.8fe1337e.svg";